import EventEmitter from "./utils/EventEmitter";
import Swiper from 'swiper';
import { Grid, Navigation, Pagination } from 'swiper/modules';

export default class Sliders extends EventEmitter {
    constructor() {
        super()

        this.miniPublicationSlider = document.querySelectorAll('.mini-publications-slider')
        this.spotlightsSliders = document.querySelectorAll('.spotlights-slider')
        this.moreInfoSliders = document.querySelectorAll('.more-info-slider')
        this.authorsSlider = document.querySelectorAll('.authors-slider')
        this.supportUsMeansSliders = document.querySelectorAll('.support-us-means-slider')
        this.testimoniesSliders = document.querySelectorAll('.testimonies-slider')
        this.donatorsSliders = document.querySelectorAll('.donators-slider')
        this.expertsContactSliders = document.querySelectorAll('.experts-contact-slider')
        this.expertInPress = document.querySelectorAll('.slider-expert-in-press')
        this.otherCenterMembers = document.querySelectorAll('.slider-other-center-members')
        this.centersSlider = document.querySelectorAll('.centers-slider')
        this.relatedProgramsSlider = document.querySelectorAll('.related-programs-slider')
        this.cardsSlider = document.querySelectorAll('.cards-slider')
        this.eventInPictures = document.querySelectorAll('.event-in-pictures-slider')
        this.gridEventSeriesSlider = document.querySelectorAll('.grid-event-serie-slider')

        this.initSliders()
    }

    initSliders() {

        const sliders = []

        if (window.innerWidth < 769) {
            this.miniPublicationSlider.forEach((el) => {
                const slider = new Swiper(el, {
                    modules: [Pagination],
                    loop: false,
                    slidesPerView: '2.15',
                    speed: 350,
                    spaceBetween: 20,
                    grabCursor: true,
                    pagination: {
                        el: el.querySelector('.swiper-pagination'),
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '"></span>';
                        },
                        dynamicBullets: true
                    },
                })
                sliders.push(slider)
            })
        }

        this.spotlightsSliders.forEach((el) => {
            const slider = new Swiper(el, {
                loop: false,
                slidesPerView: '1.1',
                spaceBetween: 20,
                grabCursor: true,
                breakpoints: {
                    769: {
                        slidesPerView: '3.5',
                        spaceBetween: 40
                    }
                }
            })

            sliders.push(slider)
        })

        this.moreInfoSliders.forEach((el) => {
            const slider = new Swiper(el, {
                loop: false,
                slidesPerView: '1.15',
                spaceBetween: 20,
                grabCursor: true,
                breakpoints: {
                    769: {
                        slidesPerView: '2',
                        spaceBetween: 40,
                    }
                }
            })
            sliders.push(slider)
        })

        this.supportUsMeansSliders.forEach((el) => {
            const slider = new Swiper(el, {
                modules: [Navigation],
                loop: false,
                slidesPerView: '1.20',
                speed: 750,
                spaceBetween: 35,
                grabCursor: true,
                centeredSlides: false,
                breakpoints: {
                    769: {
                        slidesPerView: '1.15',
                        spaceBetween: 65,
                        centeredSlides: true,
                    }
                },
                navigation: {
                    nextEl: el.querySelector('.t-btn-next'),
                    prevEl: el.querySelector('.t-btn-prev')
                }
            })
            sliders.push(slider)
        })

        this.authorsSlider.forEach((el) => {
            const slider = new Swiper(el, {
                modules: [Navigation, Pagination],
                loop: false,
                slidesPerView: '1.15',
                speed: 750,
                spaceBetween: 20,
                grabCursor: true,
                centeredSlides: false,
                breakpoints: {
                    769: {
                        slidesPerView: '3',
                        spaceBetween: 40,
                        pagination: false
                    }
                },
                navigation: {
                    nextEl: el.querySelector('.t-btn-next'),
                    prevEl: el.querySelector('.t-btn-prev')
                },
                pagination: {
                    el: el.querySelector('.swiper-pagination'),
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '"></span>';
                    },
                    dynamicBullets: true
                },
            })
            sliders.push(slider)
        })

        this.testimoniesSliders.forEach((el) => {
            const slider = new Swiper(el, {
                modules: [Navigation, Pagination],
                loop: false,
                slidesPerView: '1',
                speed: 750,
                spaceBetween: 0,
                grabCursor: true,
                centeredSlides: true,
                pagination: {
                    el: el.querySelector('.swiper-pagination'),
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '"></span>';
                    },
                    dynamicBullets: true
                },
                breakpoints: {
                    769: {
                        slidesPerView: '1',
                        spaceBetween: 65
                    }
                },
                navigation: {
                    nextEl: el.querySelector('.t-btn-next'),
                    prevEl: el.querySelector('.t-btn-prev')
                }
            })
            sliders.push(slider)
        })

        this.donatorsSliders.forEach((el) => {
            const slider = new Swiper(el, {
                loop: false,
                slidesPerView: '1.20',
                speed: 750,
                spaceBetween: 35,
                grabCursor: true
            })
            sliders.push(slider)
        })


        if (window.innerWidth < 769) {
            this.expertsContactSliders.forEach((el) => {
                const slider = new Swiper(el, {
                    modules: [Pagination],
                    loop: false,
                    slidesPerView: '1.1',
                    speed: 750,
                    spaceBetween: 20,
                    grabCursor: true,
                    pagination: {
                        el: el.querySelector('.swiper-pagination'),
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '"></span>';
                        }
                    },
                })
                sliders.push(slider)
            })
        }

        this.expertInPress.forEach((el) => {
            const slider = new Swiper(el, {
                modules: [Navigation, Pagination],
                loop: false,
                slidesPerView: '1',
                speed: 750,
                spaceBetween: 35,
                grabCursor: true,
                centeredSlides: false,
                breakpoints: {
                    769: {
                        slidesPerView: '3',
                        //spaceBetween: 180
                    }
                },
                navigation: {
                    nextEl: el.querySelector('.t-btn-next'),
                    prevEl: el.querySelector('.t-btn-prev')
                },
                pagination: {
                    el: el.querySelector('.swiper-pagination'),
                    clickable: true,
                    dynamicBullets: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '"></span>';
                    }
                },
            })
            sliders.push(slider)

            el.querySelectorAll('.swiper-slide').forEach((slide) => {
                const quoteString = slide.querySelector('.quote-by')
                const nodeTitle = slide.querySelector('.author-name')

                // On prend le contenu de quoteString et on le met dans nodeTitle à la suite du contenu déjà present dans nodeTitle
                nodeTitle.innerHTML += quoteString.innerHTML
                // On supprime quoteString
                quoteString.remove()
            })
        })


        if (window.innerWidth < 769) {
            this.otherCenterMembers.forEach((el) => {
                const slider = new Swiper(el, {
                    modules: [Pagination],
                    loop: false,
                    slidesPerView: '1.1',
                    speed: 350,
                    spaceBetween: 20,
                    grabCursor: true,
                    pagination: {
                        el: el.querySelector('.swiper-pagination'),
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '"></span>';
                        },
                        dynamicBullets: true
                    },
                })
                sliders.push(slider)
            })
        }

        this.centersSlider.forEach((el) => {
            const slider = new Swiper(el, {
                modules: [Navigation, Pagination],
                loop: false,
                slidesPerView: '1.1',
                speed: 750,
                spaceBetween: 20,
                grabCursor: true,
                breakpoints: {
                    769: {
                        slidesPerView: '3',
                        spaceBetween: 40
                    }
                },
                navigation: {
                    nextEl: el.querySelector('.t-btn-next'),
                    prevEl: el.querySelector('.t-btn-prev')
                },
                pagination: {
                    el: el.querySelector('.swiper-pagination'),
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '"></span>';
                    },
                    dynamicBullets: true
                }
            })
            sliders.push(slider)
        })

        this.cardsSlider.forEach((el) => {
            const slider = new Swiper(el, {
                modules: [Navigation],
                loop: false,
                slidesPerView: '1.2',
                speed: 450,
                spaceBetween: 30,
                grabCursor: true,
                breakpoints: {
                    769: {
                        slidesPerView: '3',
                        spaceBetween: 30
                    }
                },
                navigation: {
                    nextEl: el.querySelector('.t-btn-next'),
                    prevEl: el.querySelector('.t-btn-prev')
                }
            })
            sliders.push(slider)
        })

        this.eventInPictures.forEach((el) => {
            const slider = new Swiper(el, {
                modules: [Navigation, Grid, Pagination],
                slidesPerView: 1,
                speed: 450,
                grid: {
                    rows: 1,
                    fill: 'row'
                },
                spaceBetween: 30,
                navigation: {
                    nextEl: el.querySelector('.t-btn-next'),
                    prevEl: el.querySelector('.t-btn-prev')
                },
                pagination: {
                    el: el.querySelector('.swiper-pagination'),
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '"></span>';
                    },
                    dynamicBullets: true
                },
                breakpoints: {
                    769: {
                        slidesPerView: '3',
                        spaceBetween: 30,
                        grid: {
                            rows: 2,
                            fill: 'row'
                        },
                        pagination: false
                    }
                },
            })
            sliders.push(slider)
        })


        if (window.innerWidth < 769) {
            this.relatedProgramsSlider.forEach((el) => {
                const slider = new Swiper(el, {
                    modules: [Pagination],
                    loop: false,
                    slidesPerView: '1.1',
                    speed: 350,
                    spaceBetween: 20,
                    grabCursor: true,
                    pagination: {
                        el: el.querySelector('.swiper-pagination'),
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '"></span>';
                        },
                        dynamicBullets: true
                    },
                })
                sliders.push(slider)
            })
        }

        if (window.innerWidth < 769) {
            this.gridEventSeriesSlider.forEach((el) => {
                const slider = new Swiper(el, {
                    modules: [Grid, Pagination],
                    slidesPerView: 1,
                    spaceBetween: 20,
                    grid: {
                        rows: 2,
                        fill: 'row'
                    },
                    pagination: {
                        el: el.querySelector('.swiper-pagination'),
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '"></span>';
                        },
                        dynamicBullets: true
                    }
                })
                sliders.push(slider)
            })

        }


        sliders.forEach((slider) => {
            slider.on('slideChangeTransitionEnd', () => {
                this.trigger('slideChangeTransitionEnd')
            })
        })
    }

}
